module.exports.backend = {
    apiUrl: "https://dev.vpicking2.venturing.com.ar/vPickingCL/api",
    wsUrl: "wss://dev.vpicking2.venturing.com.ar",
    wsPath: "/vPickingCL/ws/"
};

module.exports.weight = {
    numberOfPercent : 1.5,
    toleranceValue: 0.02,
};

module.exports.sizeOfPdf = {
	width: 425,
	high: 566,
};

module.exports.countryVersion = {
    currentCountry: 'CL', // AR - CL - MX - CO - PE
    pickUpFeatures: true,
    noPostalCode: true,
    backLogDashboard: true,
    linkLabelsForPP: true,
};

module.exports.defaultBox = {
    size: 0
};

module.exports.giftsFeature = {
    active: true
};

module.exports.validatePicking = {
    active: false
}

module.exports.pickUp = {
    maximum_days_of_storage: 0,
};

module.exports.validateDelivery = {
  active: false
}
